
import User from "@/store/modules/system/user/entity";
import { Component, Mixins, FormModalMixins,appConst} from "@/lib";

@Component
export default class EditUser extends Mixins(FormModalMixins) {
  model = new User();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Edit",labelWidth:100, okAction: "system/user/update" });
  }
  get record() {
    console.warn(this.$store.state.system.user.editUser)
    return this.$store.state.system.user.editUser;
  }

  get selectList(){
    return this.$store.state.system.user.roles.map(item => {
      return {
        value:item.id,
        displayText:item.name
      }
    })
  }

  get businessGroupList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.businessGroup)
  }
}
